




































import { Component, Prop, Vue } from 'vue-property-decorator';
import PortalSelect from '@/components/new_style_components/PortalSelect.vue';
import SimpleCompanySearch from '@/components/common/SimpleCompanySearch.vue';
import SelectOption from '@/components/common/SelectOption';
import PricingProfileDTO from '@/dto/subscription/PricingProfileDTO';
import SubscriptionPlanService from '@/services/SubscriptionPlanService';
import CreateAgreementPayloadDTO from '@/dto/subscription/CreateAgreementPayloadDTO';
import Notifications from '@/state/Notifications';

@Component({ components: { PortalSelect, SimpleCompanySearch } })
export default class AddAgreementModal extends Vue {
  @Prop({ required: true }) planId!: number;
  @Prop({ required: true }) issuer!: any;
  @Prop({ required: true }) onCreated!: () => void;

  private profiles: Array<PricingProfileDTO> = [];
  private company: { id: number } | null = null;
  private startDate = '';
  private endDate: string | null = null;
  private selectedProfileId: number | null = null;
  private submitting = false;

  mounted(): void {
    this.loadProfiles();
  }

  private loadProfiles(): void {
    this.$app.startLoading();
    SubscriptionPlanService.getPricingProfiles().then(
      ok => {
        this.profiles = ok.data || [];
        this.$app.stopLoading();
      },
      err => {
        this.$app.stopLoading();
        // no fatal, allow creation without profile selection
      }
    )
  }

  get profileOptions(): Array<SelectOption> {
    const opts: Array<SelectOption> = [{ title: '— Not specified —', value: null } as SelectOption];
    return opts.concat((this.profiles || []).map(p => ({ title: `${p.name} (${p.code})`, value: p.id } as SelectOption)));
  }

  private submit(): void {
    if (!this.company?.id || !this.startDate) {
      Notifications.warning('Please select company and start date');
      return;
    }
    const payload: CreateAgreementPayloadDTO = {
      companyId: this.company.id,
      issuer: this.issuer,
      planId: this.planId,
      startDate: this.startDate,
      endDate: this.endDate || null,
      pricingProfileId: this.selectedProfileId || null,
    };
    this.submitting = true;
    this.$app.startLoading();
    SubscriptionPlanService.createAgreement(payload).then(
      () => {
        this.$app.stopLoading();
        this.submitting = false;
        Notifications.success('Agreement created');
        this.onCreated();
      },
      err => {
        this.$app.stopLoading();
        this.submitting = false;
        // error already processed globally elsewhere; show fallback
        Notifications.error('Failed to create agreement');
      }
    )
  }

  private cancel(): void {
    this.$modal.hideAll();
  }

  private displayIssuer(issuer: any): string {
    if (issuer && typeof issuer === 'object') {
      return issuer.fullName || issuer.abbreviation || JSON.stringify(issuer);
    }
    if (typeof issuer === 'string') {
      return this.$stringUtils.enumToFormattedSentence(issuer);
    }
    return String(issuer);
  }
}
